import http from 'plugins/axios'

export default {
  getUserList({
    page = 1,
    size = 25,
    queryType,
    queryValue,
    realName,
    userStatus,
    userType,
    mark,
    tenantId
  }) {
    return http.get({
      url: `/la/admin/trade/user/${page}/${size}`,
      data: {
        queryType,
        queryValue,
        realName,
        userStatus,
        userType,
        mark,
        tenantId
      },
    })
  },
  updateVolunteer({ id, status }) {
    return http.post({
      url: `/la/admin/trade/user/updateStatus/${id}`,
      data: {
        userVolunteerStatus: status,
      },
      dataType: 'form',
    })
  },
  updateBlocking({ id, status, content }) {
    return http.post({
      url: '/la/admin/trade/user/updateUserStatus',
      data: {
        id,
        userStatus: status,
        content: content,
      },
      dataType: 'form',
    })
  },
  cancelGoogle(data) {
    return http.post({
      url: '/la/admin/user/delete/googleAuth',
      data,
      dataType: 'form',
    })
  },
  coutryCode() {
    return http.get({
      url: '/la/admin/countryCodeList',
    })
  },
  updatInfo(data) {
    return http.post({
      url: '/la/admin/user/update/tel',
      data,
      dataType: 'form',
    })
  },
  updateUserType(data) {
    return http.post({
      url: '/la/admin/user/userType/update',
      data,
      dataType: 'form',
    })
  },
  updateDividendStatus(data) {
    return http.post({
      url: '/la/admin/user/dividend/status/update',
      data,
      dataType: 'form',
    })
  },
  setNode(data) {
    return http.post({
      url: '/la/admin/starplan/create/node',
      data,
      dataType: 'form',
    })
  },
  resetPassword(data) {
    return http.post({
      url: '/la/admin/user/password/reset',
      data,
      dataType: 'form',
    })
  },
  updateMark(data) {
    return http.post({
      url: '/la/admin/user/mark',
      data,
      dataType: 'form',
    })
  },
  addUser(data) {
    return http.post({
      url: `/la/admin/trade/user/save`,
      data,
      dataType: 'form'
    })
  },
  showAccount({ userId }) {
    return http.get({
      url: `/la/admin/user/getById?userId=${userId}`,
    })
  },
  checkGoogle({ googleCode }) {
    return http.post({
      url: `/la/admin/google/check?googleCode=${googleCode}`,
    })
  },
  delPositionId(positionId) {
    return http.post({
      url: `/la/admin/channel/position/deleteHistory?positionId=${positionId}`,
    })
  },
}
